import { CircleCheckIcon, InfoIcon, OctagonXIcon, TriangleAlertIcon } from "lucide-react";
import type * as React from "react";
import { Toaster as Sonner, type ToasterProps, toast } from "sonner";

// The mock's .toast: ink background, surface text, bottom centre.
function Toaster(props: ToasterProps) {
  return (
    <Sonner
      position="bottom-center"
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
      }}
      style={
        {
          "--normal-bg": "var(--color-ink)",
          "--normal-text": "var(--color-surface)",
          "--normal-border": "var(--color-ink)",
          "--border-radius": "10px",
        } as React.CSSProperties
      }
      {...props}
    />
  );
}

export { Toaster, toast };
